const $ = window.jQuery;
const $window = $window || $(window);

const AnimateOnPageLinks = {

    offset: -100,

    init () {

        $('a').on('click', (e) => {

            let $link = $(e.target);

            if (this.is_excluded($link)) {
                return;
            }

            let href = $link.attr('href');

            if (this.link_is_targeting_on_page_anchor(href)) {

                let $target_element = $(href);
                if (!$target_element.length) {
                    return;
                }

                e.preventDefault();

                let scroll_top = $target_element.offset().top + this.offset;

                // subtract any additional height considerations to scroll_top (e.g; height of sticky header)
                //scroll_top -= $('.oxy-sticky-header-active').outerHeight();

                $('html, body').animate({scrollTop: scroll_top}, 600, 'swing', () => $target_element.trigger('scrolled_to'));
            }

        });

    },

    is_excluded ($selector) {
        return !!$selector.data('toggle');
    },

    link_is_targeting_on_page_anchor (link) {
        return /^#/.test(link);
    }

};

export default AnimateOnPageLinks;